import { render, staticRenderFns } from "./AbsentsGrid.vue?vue&type=template&id=5c42635b"
import script from "./AbsentsGrid.vue?vue&type=script&lang=js"
export * from "./AbsentsGrid.vue?vue&type=script&lang=js"
import style0 from "./AbsentsGrid.vue?vue&type=style&index=0&id=5c42635b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports